<template>
  <div>
    <Top></Top>
    <div class="bg">
      <h2>ラクコネクト株式会社 </h2>
    </div>
    <div class="main">
      <!-- <div class="txt">
        <h3>Rakumartについて</h3>
        <p>
          Rakumartの運営会社となる「申越網絡科技有限公司」は、アリババとタオバオの発祥地である浙江省杭州市にあります。世界最大の日用雑貨卸売り市場を有する、「百円ショップ」のふるさととも呼ばれる同省義烏市に業務母体を構えており
          ます。現時点の従業員総数は100人に達し、営業面積は6000平米を超えています。
        </p>
        <p>
          Rakumartでは、最先端IT技術の開発・導入により、中国における優良サプライヤーと世界中の中小仕入れ業者との繋がりを密接にし、「世界工場」ならでの優れた商品を世界に流通させ、より透明な情報開示、よりスムーズな業務遂行、より
          安心、安全、簡単クネット貿易モデルの作り上げを目標に挙げております。商品リサーチからネット仕入れ、輸出入、OEM、検品、在庫管理、国際輸出、海外倉庫までの一貫した完
        </p>
      </div> -->
      <div class="she">
        <div class="fl benshe">
          <span>日本本社</span>
        </div>
        <div class="fr content">
          <ul>
            <li>
              <h6>社名</h6>
              <p>ラクコネクト株式会社</p>
            </li>
            <li>
              <h6>所在地</h6>
              <p>〒557-0032</p>
              <p>大阪市西成区旭二丁目１番28-402号</p>
            </li>
            <li>
              <h6>Tel</h6>
              <p>06-7632-7856</p>
            </li>
            <li>
              <h6>メール</h6>
              <p>services@rakumart.com</p>
            </li>
          </ul>
          <div class="daguan">
            <div class="img">
              <!-- <img src="../../assets/img/boss.jpg" alt /> -->
            </div>
            <h6>
              代表
              <span>山口秋男</span>
            </h6>
          </div>
        </div>
      </div>
      <!-- <div class="she">
        <div class="fl benshe">
          <span>中国支社</span>
        </div>
        <div class="fr content" style="background: #fff">
          <ul>
            <li>
              <h6>社名</h6>
              <p>杭州申越网络科技有限公司</p>
            </li>
            <li>
              <h6>所在地</h6>
              <p>〒558-浙江省杭州市滨江区星耀城一期1704＃</p>
            </li>
            <li>
              <h6>Tel</h6>
              <p>0571-8717-0622</p>
            </li>
            <li>
              <h6>メール</h6>
              <p>services@rakumart.com</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="she">
        <div class="fl benshe">
          <span>中国本社</span>
        </div>
        <div class="fr content">
          <ul>
            <li>
              <h6>社名</h6>
              <p>义乌市合道电子商务有限公司</p>
            </li>
            <li>
              <h6>所在地</h6>
              <p>浙江省金华市义乌市 景三路37号2号楼</p>
            </li>
            <li>
              <h6>Tel</h6>
              <p>0579-8520-7520</p>
            </li>
          </ul>
        </div>
      </div> -->
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {

    };
  },
  components: {
    Top,
    Foot,
  },
  created() {
    this.list
  },
  methods: {
    list() {

    },
  },
};
</script>
<style lang='scss' scoped>
.bg {
  width: 100%;
  height: 450px;
  background: url("../../assets/img/companyIntroduce.jpg") no-repeat;
  background-size: 100% 100%;

  h2 {
    font-size: 30px;
    line-height: 450px;
    text-align: center;
    color: #fff;
  }
}

.main {
  width: 1200px;
  margin: 100px auto 20px;

  .txt {
    margin-bottom: 100px;

    h3 {
      text-align: center;
      margin-bottom: 50px;
      font-size: 30px;
    }

    p {
      text-indent: 2em;
      font-size: 16px;
      margin-bottom: 40px;
      line-height: 20px;
    }

  }

  .she {
    overflow: hidden;
    margin-bottom: 100px;

    .benshe {
      span {
        display: inline-block;
        padding-left: 10px;
        height: 40px;
        line-height: 40px;
        border-left: 5px solid #999;
        font-size: 26px;
        font-weight: 700;
      }
    }

    .content {
      width: 750px;
      background: #f5f5f5;
      padding: 15px 15px 0;
      position: relative;

      li {
        margin-bottom: 33px;

        h6 {
          font-size: 22px;
          font-weight: 700;
        }

        p {
          font-size: 16px;
        }
      }

      .daguan {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 40px;

       

        h6 {
          margin-top: 10px;
          font-size: 20px;
          font-weight: 700;
          text-indent: 1em;

          span {
            padding-left: 10px;
          }
        }
      }
    }
  }
}
</style>